import { useDefaultAnalyticsParams } from "core/analytics/analytics-params.hooks";
import { CustomEventProperties } from "core/analytics/analytics.types";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";

export const useAppInsightsPageViewTracker = () => {
  const appInsightPlugin = useAppInsightsContext();
  const location = useLocation();
  const defaultParams = useDefaultAnalyticsParams();

  useEffect(
    () => {
      appInsightPlugin.trackPageView &&
        appInsightPlugin.trackPageView({
          name: document.title,
          uri: location.pathname,
          properties: defaultParams
        });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [appInsightPlugin, location]
  );
};

export const useAppInsightsTrackEvent = () => {
  const appInsights = useAppInsightsContext();
  return (name: string, params: CustomEventProperties) =>
    appInsights.trackEvent({ name, properties: params });
};
